import React from 'react';
import ReactDOM from 'react-dom';
import { Meteor } from 'meteor/meteor';
import { Reactive } from '../../common/Reactive.mixin.js';
import Moment from 'react-moment';

import {
  FormGroup,
  BPanel,
  Button,
  Table,
  FormControl,
  Col
} from '@sketchpixy/rubix';

import { Payments } from '../../../collections/reservations/payments';

@Reactive({
	subscriptions: ["payments"],
})
export class BillingComponent extends React.Component {

	constructor(props) {
	  super(props);
	  this.state = {};
	}

	addPayment() {

		let payment = {
			'type': ReactDOM.findDOMNode(this.refs.type).value.trim(),
			'montant': ReactDOM.findDOMNode(this.refs.montant).value.trim(),
			'informations': ReactDOM.findDOMNode(this.refs.informations).value.trim(),
			'reservation': this.props.reservation._id
		};

		Meteor.call('payments.insert', payment, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: "Erreur..." + err,
					type: "error"
				});
				return;
			}

			Messenger().post({
				message: "Le paiement a été enregistré.",
				type: "success"
			});

			ReactDOM.findDOMNode(this.refs.type).value = '';
			ReactDOM.findDOMNode(this.refs.montant).value = '';
			ReactDOM.findDOMNode(this.refs.informations).value = '';
		}));

	}

	removePayment(event) {

		if(confirm('Êtes-vous sûr de vouloir supprimer ce paiement ?')) {

			Meteor.call('payments.remove', event.target.value, (function (err, _id) {
				if (err) {
					Messenger().post({
						message: "Erreur..." + err,
						type: "error"
					});
					return;
				}

				Messenger().post({
					message: "Le paiement a été supprimé.",
					type: "success"
				});
			}));

		}
	}

	renderPayments() {
		return this.props.payments && this.props.payments.map((payment) => (
			<tr>
        <td><Moment format="DD/MM/YYYY à kk:mm">{payment.createdAt}</Moment></td>
				<td>{payment.type}</td>
				<td>{payment.montant}€</td>
				<td>{payment.informations}</td>
				<td><center><Button bsStyle="danger" onClick={this.removePayment.bind(this)} value={payment._id}>X</Button></center></td>
			</tr>
		));
	}

  	render() {
	    return (
	    	<BPanel header="Etat de la facturation">
	    		<strong>Restant : &nbsp;</strong>
	    		{this.props.reservation.getSolde() > 0 &&
	    			<Button bsStyle="danger">{this.props.reservation.getSolde()} €</Button>
	    		}
	    		{this.props.reservation.getSolde() <= 0 &&
	    			<Button bsStyle="success">{this.props.reservation.getSolde()} €</Button>
	    		}
	    		<br/>
	    		<hr/>
	    		<Col sm={3}>
					<FormControl componentClass="select" type="select" ref="type">
							<option value="Especes">Especes</option>
							<option value="CB internet">CB internet</option>
							<option value="CB">CB</option>
							<option value="Chèque">Chèque</option>
							<option value="Virement">Virement</option>
							<option value="Autre">Autre</option>
					</FormControl>
				</Col>
	    		<Col sm={3}>
	    			<FormControl placeholder="Montant" type="text" ref="montant"/>
	    		</Col>
	    		<Col sm={3}>
	    			<FormControl placeholder="Informations" type="text" ref="informations"/>
	    		</Col>
	    		<Col sm={3}>
	    			<Button bsStyle="primary" onClick={this.addPayment.bind(this)}>Ajouter</Button>
	    		</Col>

	    		<br/><hr/>

			    {this.props.payments.length > 0 &&
				    <Table striped bordered responsive>
				    	<thead>
				    		<tr>
				    			<td>Date</td>
				    			<td>Type</td>
				    			<td>Montant</td>
				    			<td>Informations</td>
				    			<td>-</td>
				    		</tr>
				    	</thead>
				    	<tbody>
				    		{this.renderPayments()}
				    	</tbody>
				    </Table>
				}
				{this.props.payments.length == 0 &&
					<p>Il n'y a pas encore de paiement</p>
				}
	    	</BPanel>
	    );
  	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-billing.js
 **/